<div class="user-management-heading-info">
    <div class="align-h width-stretch">
        <div class="stretch">Name</div>
        <div class="stretch">Email ID</div>
        <div class="stretch">Mobile No</div>
        <div class="width-200 margin-right-10"></div>
    </div>
</div>
<mat-accordion>

    <mat-expansion-panel
        *ngFor="let investor of investorList"
        class="margin-bottom-20"
        (opened)="panelMap[investor?.id] = true"
        (closed)="panelMap[investor?.id] = false"
        [expanded]="panelMap[investor?.id]"
    >
      <mat-expansion-panel-header>
                <div class="align-h width-stretch">
                    <div class="stretch">{{ investor?.name }}</div>
                    <div class="stretch">{{ investor?.email }}</div>
                    <div class="stretch">{{ investor?.mobile }}</div>
                    <div class="align-h width-200">
                        <div class="stretch">
                            <button
                                mat-icon-button
                                [color]="investor?.isBlocked ? 'primary': 'secondary'"
                                (click)="$event.stopPropagation(); openBlockOrUnblockDialog(investor)"
                            >
                                <mat-icon>block</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
        </mat-expansion-panel-header>
        <ng-template [ngIf]="panelMap[investor?.id]">
            <div class="align-h width-stretch">
                <div class="stretch">Pan: {{ investor?.pan }}</div>
                <div class="stretch">
                    Status: {{ investor?.empanelmentStatus }}
                </div>
            </div>
        </ng-template>
    </mat-expansion-panel>
</mat-accordion>
